<template>
  <div class="promocode-form-container ">
    <div class="promocode-child-container1">
      <b-form-group
        style="width: 90%; margin-right: 1rem; margin-bottom: 0rem;"
      >
        <b-form-input
          id="promotionalCode"
          placeholder="Enter Promo Code"
          v-model="promoCodeSearchInput"
          type="text"
        />
      </b-form-group>

      <button
        type="button"
        class="btn btn-primary"
        @click="
          verifyPromoCode(
            {
              tenantAlias,
              email,
              transactionType,
              recurringFrequency
            },
            authenticationMode
          )
        "
        :disabled="promoCodeSearchInput.length == 0"
      >
        Verify
      </button>
    </div>

    <div
      v-if="value.success"
      class="promocode-child-container3 shadow-sm p-3 mb-5 bg-white rounded"
    >
      <div class="promocode-child-container2">
        <span class="applied-code">{{ value.code }}</span>
        <span class="applied-code">{{ formattedDiscountAmount }}</span>

        <button type="button" @click="resetPromoCodeDetails()">
          <i class="fa-regular fa-circle-xmark fa-lg"></i>
        </button>
      </div>
      <div v-if="value.recurring.freeTrial" class="promocode-child-container2">
        <span class="applied-code2">{{ freeTrialMessage }}</span>
      </div>
      <div v-if="value.recurring.discount" class="promocode-child-container2">
        <span class="applied-code2">
          Recurring Discount:
          {{ formattedRecurringDiscountAmount }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import { currencyFormat } from "../../services/Formatting";
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    tenantAlias: {
      type: String,
      required: false
    },
    email: {
      type: String,
      required: true
    },
    transactionType: {
      type: String,
      required: true
    },
    authenticationMode: {
      type: String,
      required: false
    },
    recurringFrequency: {
      type: String,
      required: false
    },
    amount: {
      type: Number,
      required: false
    },
    recurringAmount: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      promoCodeSearchInput: ""
    };
  },
  computed: {
    discountAmount() {
      const value = this.value;
      if (!value.success) return null;
      if (!value.discount) return null;
      if (value.discount.type == "Percentage") {
        return this.amount * (value.discount.amount / 100);
      }
      return value.discount.amount;
    },
    recurringDiscountAmount() {
      const value = this.value;
      if (!value.success) return null;
      if (!value.recurring.discount) return null;
      if (value.recurring.discount.type == "Percentage") {
        return this.recurringAmount * (value.recurring.discount.amount / 100);
      }
      return value.recurring.discount.amount;
    },
    formattedDiscountAmount() {
      if (!this.discountAmount) return null;
      return `- $${currencyFormat(this.discountAmount)}`;
    },
    formattedRecurringDiscountAmount() {
      if (!this.recurringDiscountAmount) return null;
      return `- $${currencyFormat(this.recurringDiscountAmount)}`;
    },
    formattedRecurringfrequency() {
      if (!this.value.recurring.freeTrial) return null;

      switch (this.value.recurring.freeTrial.frequency) {
        case "Daily":
          return "days";
        case "Weekly":
          return "weeks";
        case "Fortnightly":
          return "fortnights";
        case "Monthly":
          return "months";
          authenticationModeauthM;
        case "BiMonthly":
          return "bimonths";
        case "Quarterly":
          return "quarters";
        case "Yearly":
          return "years";
        default:
          return null;
      }
    },
    freeTrialMessage() {
      if (!this.value.recurring.freeTrial) return null;
      return `The first ${this.value.recurring.freeTrial.period} ${this.formattedRecurringfrequency} of your payment will be free.`;
    }
  },
  methods: {
    async verifyPromoCode(
      { tenantAlias, email, transactionType, recurringFrequency },
      authenticationMode
    ) {
      try {
        const response = await this.getPromocodeDiscountInformation(
          {
            tenantAlias,
            email,
            transactionType,
            recurringFrequency
          },
          authenticationMode
        );
        const success = response.data.verifyPromoCode.success;
        const error = response.data.verifyPromoCode.error;
        if (!success) throw new Error(error);

        this.updatePromoCode(response.data.verifyPromoCode);
        this.createToast("success", "Promocode Added Successfully");
      } catch (error) {
        this.createToast(
          "danger",
          error?.message ?? "Something went wrong trying to apply promocode"
        );

        this.$logger.error(error);
      }
    },
    async getPromocodeDiscountInformation(promoCodeRequest, authMode) {
      const query = `
        query VerifyPromoCode($body: VerifyPromoCodeInput!) {
          verifyPromoCode(body: $body) {
            success
            error
            discount {
              amount
              type
            }
            code
            description
            recurring {
              discount {
                amount
                type
              }
              freeTrial {
                period
                frequency
              }
            }
          }
        }
      `;

      const data = await API.graphql({
        ...graphqlOperation(query, {
          body: { ...promoCodeRequest, code: this.promoCodeSearchInput }
        }),
        authMode: authMode
      });
      return data;
    },
    updatePromoCode(response) {
      const promoCodeDetails = {
        success: response.success,
        discount: response.discount,
        code: response.code,
        description: response.description,
        recurring: response?.recurring
          ? response.recurring
          : {
              discount: null,
              freeTrial: null
            }
      };
      this.$emit("input", promoCodeDetails);
    },
    resetPromoCodeDetails() {
      this.$emit("input", {
        success: null,
        discount: null,
        code: null,
        description: null,
        recurring: {
          discount: null,
          freeTrial: null
        }
      });
    },
    createToast(variant, message) {
      this.$bvToast.toast(message, {
        title: "Promo Code Settings",
        autoHideDelay: 5000,
        variant,
        append: true
      });
    }
  }
};
</script>

<style scoped>
.promocode-form-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.promocode-child-container1 {
  width: 80%;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.promocode-child-container3 {
  width: 80%;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.promocode-child-container2 {
  width: 100%;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.applied-code {
  font-weight: 400;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.applied-code2 {
  font-weight: 400;
  font-size: 1.2rem;
}
</style>
